// src/ui/clarity.ts
// Microsoft Clarity wrapper. All calls are guarded by `typeof clarity` so
// they no-op when the script is blocked or hasn't loaded. Loading is gated
// by EU cookie consent — call loadClarity() only after the user accepts.

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

const CLARITY_PROJECT_ID = 'wdtm0m0gf0';

let loaded = false;

export function loadClarity(): void {
  if (loaded) return;
  loaded = true;
  // Standard Clarity install snippet, expanded for clarity.
  const c = CLARITY_PROJECT_ID;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${c}`;
  // Initialize the function queue before the script loads.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).clarity = (window as any).clarity || function (...args: unknown[]) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ((window as any).clarity.q = (window as any).clarity.q || []).push(args);
  };
  document.head.appendChild(script);
}

export function event(name: string): void {
  if (typeof window.clarity === 'function') {
    try { window.clarity('event', name); } catch { /* swallow */ }
  }
}

export function tag(key: string, value: string | number | boolean): void {
  if (typeof window.clarity === 'function') {
    try { window.clarity('set', key, String(value)); } catch { /* swallow */ }
  }
}
